import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

interface IStyledLink {
  invisible?: boolean
  wrapped?: boolean
  color?: string
}

// TODO: Props passed to styled component should be string type
// https://github.com/styled-components/styled-components/issues/1198 @Misha
export const StyledLink = styled(Link)<IStyledLink>`
  ${({ invisible }) =>
    invisible &&
    css`
      all: unset;
    `}
  cursor: pointer;

  ${({ wrapped }) =>
    wrapped &&
    css`
      display: flex;
      align-items: center;
    `}
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
` as any
